import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import {
  AUTO_STYLE,
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { OfferComponent } from '../../components/offer/offer.component';
import { RouterLink, RouterLinkActive } from '@angular/router';

const DEFAULT_DURATION = 300;

@Component({
  selector: 'app-offers',
  standalone: true,
  imports: [TranslateModule, OfferComponent, RouterLink, RouterLinkActive],
  templateUrl: './offers.component.html',
  styleUrl: './offers.component.css',
  animations: [
    trigger('collapse', [
      state('false', style({ height: AUTO_STYLE, visibility: AUTO_STYLE })),
      state('true', style({ height: '0', visibility: 'hidden' })),
      transition('false => true', animate(DEFAULT_DURATION + 'ms ease-in')),
      transition('true => false', animate(DEFAULT_DURATION + 'ms ease-out')),
    ]),
  ],
})
export class OffersComponent {}
